// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { TermsInfoResult } from "@mcmc/App/Services/AccountCreationService";
import { Draft } from "immer";
import { ReactNode } from "react";

export type LayoutState = {
    isFullWidth: boolean;
    fullWidthContainers: { [key: string]: string };
    breadcrumbActions: ReactNode | null;
    isMoblico?: boolean;
    acceptTermsInfo?: TermsInfoResult;
};

const initialLayoutState: LayoutState = {
    isFullWidth: false,
    fullWidthContainers: {},
    breadcrumbActions: null,
};

const xLayout = createTypedReducerWithImmer(initialLayoutState, {
    "xLayout/SetFullWidth": (draft: Draft<LayoutState>, action: { isFullWidth: boolean; widgetId: string }) => {
        if (action.isFullWidth) {
            draft.fullWidthContainers[action.widgetId] = "fullWidth";
        } else {
            delete draft.fullWidthContainers[action.widgetId];
        }

        draft.isFullWidth = Object.keys(draft.fullWidthContainers).length > 0;
    },
    "xLayout/SetBreadcrumbActions": (draft: Draft<LayoutState>, action: { breadcrumbActions: ReactNode | null }) => {
        draft.breadcrumbActions = action.breadcrumbActions;
    },
    "xLayout/SetIsMoblico": (draft: Draft<LayoutState>, action: { isMoblico: boolean }) => {
        draft.isMoblico = action.isMoblico;
    },
    "xLayout/SetAcceptTermsInfo": (draft: Draft<LayoutState>, action: { acceptTermsInfo: TermsInfoResult }) => {
        draft.acceptTermsInfo = action.acceptTermsInfo;
    },
    "Context/CompleteLoadSession": (draft: Draft<LayoutState>) => {
        draft.acceptTermsInfo = undefined;
    },
});

(reducers as any).xLayout = xLayout;

type xLayoutReducers = {
    xLayout: typeof xLayout;
};

export type xLayoutActions = Parameters<xLayoutReducers[keyof xLayoutReducers]>[1] | AnyAction;
